import { Routes } from '@angular/router';
import { DIETLESS_CONFIG } from './app.config';
import { environment } from '@app/env';
import { MetaReducer } from '@ngrx/store';
import bugsnag from '@bugsnag/js';
import { BugsnagErrorHandler } from '@bugsnag/plugin-angular';
import { storeFreeze } from 'ngrx-store-freeze';
export var metaReducers = !environment.production ? [storeFreeze] : [];
export function appBaseHrefFactory() {
    return environment.BASE_HREF;
}
var routes = [
    {
        path: '',
        loadChildren: './shell/shell.module#ShellModule'
    }
];
var bugsnagClient = bugsnag('edd2e3806dc146f07b5d2fcfea699597');
window['Bugsnag'] = bugsnagClient;
// create a factory which will return the bugsnag error handler
export function bugsnagErrorHandlerFactory() {
    return new BugsnagErrorHandler(bugsnagClient);
}
var ɵ0 = DIETLESS_CONFIG;
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0 };
